<template>
    <div class="project-content-duplication">
        <design-2021-apprentice-multistep-form-wizard-form-header-component
            :title="$t('lesson_module.select_lesson_module')"
            :description="description">
        </design-2021-apprentice-multistep-form-wizard-form-header-component>

        <div class="lesson-module-selector">
            <b-alert
                class="projecttype-name-error"
                v-if="hasError"
                show
                variant="danger">
                {{ $t('multistep.lesson_module_cannot_be_empty') }}
            </b-alert>

            <b-form-group
                class="education-level-group"
                v-if="educationLevelsIn.length > 1"
                :label="$t('common.choose_a_level')"
                label-for="education-level-select">
                <b-form-select
                    class="apprentice-primary-select"
                    id="education-level-select"
                    v-model="selectedEducationLevel"
                    :options="selectableEducationLevels">
                </b-form-select>
            </b-form-group>

            <b-form-group
                class="lesson-module-group"
                v-if="selectableLessonModules.length"
                :label="$t('group.create.choose_lesson_module')"
                label-for="lesson-module-select">
                <template v-slot:label>
                    {{ $t('group.create.choose_lesson_module') }}: <span class="required">*</span>
                </template>
                <b-form-select
                    class="apprentice-primary-select"
                    id="lesson-module"
                    v-model="selectedLessonModule"
                    :options="selectableLessonModules"
                    @input="updateSelectedGroup">
                </b-form-select>
            </b-form-group>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'design-2021-multistep-wizard-creathlon-project-content-step-component',
        props: {
            educationLevelsIn: Array
        },
        data() {
            return {
                description: this.$t('group.create.choose_lesson_module_description'),
                selectedEducationLevel: null,
                selectedLessonModule: null,
                hasError: false
            };
        },
        computed: {
            selectableEducationLevels() {
                return this.educationLevelsIn.map((el) => {
                    return {
                        value: el,
                        text: el.name
                    };
                });
            },
            selectableLessonModules() {
                if (this.selectedEducationLevel) {
                    return this.selectedEducationLevel.lesson_modules.map((lm) => {
                        return {
                            value: lm,
                            text: lm.name
                        };
                    });
                }
                return [];
            }
        },
        mounted() {
            if (this.educationLevelsIn.length === 1) {
                this.selectedEducationLevel = this.educationLevelsIn[0];
            }
        },
        methods: {
            updateSelectedGroup() {
                this.$emit('input', {
                    source_id: this.selectedLessonModule.id,
                    source_name: this.selectedLessonModule.name
                });
            },

            async checkForErrors() {
                this.hasError = false;

                if (this.selectedLessonModule === null) {
                    this.hasError = true;
                    const response = true;
                    return await response;
                }
            }
        }
    };
</script>

<style scoped lang="scss"></style>
